import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_2 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!

  return (_openBlock(), _createBlock(_component_v_list_item_content, null, {
    default: _withCtx(() => [
      (_ctx.child)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.child.lastName) + " " + _toDisplayString(_ctx.child.firstName) + " ", 1),
              (_ctx.childAttendance(_ctx.child.childId))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.childAttendance(_ctx.child.childId).absence === 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.childAttendance(_ctx.child.childId).status === 1)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                color: "primary",
                                class: "mx-2",
                                outlined: "",
                                small: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkedIn')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.childAttendance(_ctx.child.childId).status === 2)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 1,
                                color: "secondary",
                                class: "mx-2",
                                outlined: "",
                                small: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('attendance.checkedOut')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.childAttendance(_ctx.child.childId).absence === 1)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          color: "grey",
                          class: "mx-2",
                          outlined: "",
                          small: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('attendance.absent')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.childAttendance(_ctx.child.childId).pickup)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (
                _ctx.childAttendance(_ctx.child.childId).pickup.pickup.by ||
                  _ctx.childAttendance(_ctx.child.childId).pickup.dropOff.by
              )
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                color: "orange",
                                class: "mx-2",
                                outlined: "",
                                small: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('attendance.pickupChanged')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_2, [
              (_ctx.childChatSummary.comment)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    color: "#E190CF"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-note-outline", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.childChatSummary.chatUnreadCount > 0)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 1,
                    color: "primary",
                    class: "mx-2 pa-2",
                    small: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.childChatSummary.chatUnreadCount), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-chevron-right", -1)
                ]))]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}